import config from "../config";
import { PlateType, PlateTypeCalibration } from "../Model/PlateType";
import {
  concatOptionalParameter,
  sendGetRequest,
  sendPostRequest,
} from "./../Utility/FetchUtils";
import { sendDownloadTextRequest } from "../Utility/FetchUtils";
import DateUtil from "../Utility/DateUtil";
import { PlateTypeBackupEntry } from "../Model/Plate";

class PlateTypeApi {
  static BASE_URL = config.SERVICE_URL + "/plate-types";

  static sync() {
    let url = this.BASE_URL + "/sync";
    return sendPostRequest(url);
  }

  static getPlateTypes(id?: number) {
    let url = this.BASE_URL;
    url = concatOptionalParameter(url, {
      id: id,
    });

    return sendGetRequest<PlateType[]>(url);
  }

  static getPlateTypeReport() {
    let url = this.BASE_URL + "/report";

    return sendDownloadTextRequest(url, `PlateTypesReport.txt`);
  }

  static exportPlateTypeXml(
    id: number,
    imagerIdentifier: string,
    plateTypeName: string
  ) {
    let url = this.BASE_URL + "/" + id + "/" + imagerIdentifier;

    return sendDownloadTextRequest(url, `${plateTypeName}.xml`);
  }

  static backupPlateType(id: number, imagerIdentifier: string, note: string) {
    let url = this.BASE_URL + `/:backup/${id}/${imagerIdentifier}`;

    return sendPostRequest(url, note);
  }

  static restorePlateType(
    backupId: number,
    plateTypeId: number,
    imagerIdentifier: string
  ) {
    let url =
      this.BASE_URL + `/:restore/${backupId}/${plateTypeId}/${imagerIdentifier}`;

    return sendPostRequest(url);
  }

  static importPlateTypeXml(
    id: number,
    imagerIdentifier: string,
    plateTypeXml: string
  ) {
    let url = this.BASE_URL + "/" + id + "/" + imagerIdentifier;

    return sendPostRequest(url, plateTypeXml);
  }

  static getPlateTypeBackupEntries(
    plateTypeId: number,
    startDate: Date,
    endDate: Date
  ): Promise<PlateTypeBackupEntry[]> {
    let url =
      this.BASE_URL +
      `/backup/${plateTypeId}/${DateUtil.toString(
        startDate
      )}/${DateUtil.toString(endDate)}`;

    return sendGetRequest(url);
  }

  static checkPlateTypeXml(plateTypeXml: string) {
    let url = this.BASE_URL + "/:check-xml";

    return sendPostRequest(url, plateTypeXml);
  }

  static setPlateTypeCalibration(
    id: number,
    imagerIdentifier: string,
    plateTypeCalibration: PlateTypeCalibration,
    updateReferencePointForAllPlates: boolean
  ) {
    const url =
      this.BASE_URL +
      "/" +
      id +
      "/calibrations/" +
      imagerIdentifier +
      "/" +
      updateReferencePointForAllPlates;

    return sendPostRequest(url, plateTypeCalibration);
  }

  static getPlateTypeCalibration(id: number, imagerIdentifier: string, withOffsetCurrentLightpath: boolean) {
    let url = this.BASE_URL + "/" + id + "/calibrations/" + imagerIdentifier + "/" + withOffsetCurrentLightpath;

    return sendGetRequest<PlateTypeCalibration>(url);
  }
}

export default PlateTypeApi;
